<template>
  
  <div class="content-overflow"
  
  >
  
  <div class="content-wrapper"
 
  >

  
    <div class="content-body"
        v-for="(item,index) in actualView.bodyContent"
        :key="index"
    >
        <InfoTitle
          v-if="item.contentTitle"
          :contentTitle="item.contentTitle"
        >            
        </InfoTitle>

        <InfoText
          v-if="item.contentText"
          :contentText="item.contentText"
        >            
        </InfoText>

        <InfoImage
          v-if="item.contentImage"
          :contentImage="item.contentImage"
        >
        </InfoImage>

        <InfoPercent
          v-if="item.contentPercent"
        >
        </InfoPercent>

    </div>

  </div>
  
    <UserFeedback
        v-if="actualView.feedback"
      />

  </div>
  </template>
  
 <script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import InfoTitle from '@/components/game/InfoTitle.vue'
import InfoText from '@/components/game/InfoText.vue'
import InfoImage from '@/components/game/InfoImage.vue'
import UserFeedback from '@/components/game/UserFeedback.vue'
import InfoPercent from "@/components/game/InfoPercent.vue"

export default {
    name: "InfoContent",
    data() {
      return {
        isAccept: false
      }
    },
    components: {
        InfoTitle,
        InfoText,
        InfoImage,
        UserFeedback,
        InfoPercent        
    },
    computed: {
      ...mapGetters([
          "gameData",
          "stepNumber",
          "actualView",
          "actualProperty"
      ])
    },
    methods: {
      ...mapActions([
          "setAcceptCheckbox"
      ]),
      changeAccept() {
        this.isAccept = !this.isAccept
        this.setAcceptCheckbox(this.isAccept)
      }
    }
}
</script>

<style>

</style>